import { hFetch as deprecatedHFetch } from './hFetch';
import type { UserTaskEntity } from './entity_types/UserTask';
import type { ContactEntity } from './entity_types/Contact';
import type { ContactMessageEntity } from './entity_types/ContactMessage';
import { hFetch } from '@/lib/hfetch';

export type GetContactTaskResponse = UserTaskEntity & { user: { name: string; email: string } };
export const getContactTasks = async ({ id }: { id: number }) => {
  return await hFetch<GetContactTaskResponse[]>({ url: `/api/contacts/${id}/tasks` });
};

export const deleteContactTask = async ({ contactId, userTaskId }: { contactId: string; userTaskId: number }) => {
  return await hFetch({
    url: `/api/contacts/${contactId}/tasks/${userTaskId}`,
    method: 'DELETE',
  });
};

type UpdateContactTaskPayload = { user_task: { status: string } };

export const updateContactTask = async ({
  contactId,
  userTaskId,
  payload,
}: {
  contactId: string;
  userTaskId: number;
  payload: UpdateContactTaskPayload;
}) => {
  return await hFetch<UserTaskEntity, UpdateContactTaskPayload>({
    url: `/api/contacts/${contactId}/tasks/${userTaskId}`,
    method: 'PATCH',
    payload,
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getContact = (contactId: string): Promise<any> => {
  return deprecatedHFetch({ url: `/api/contacts/${contactId}` });
};

export type ContactHistoryVersion = {
  version: {
    object_changes: Record<string, [unknown, unknown]> | null;
    created_at: string;
  };
  whodunnit: string;
};

export const getContactHistory = (contactId: string | number) => {
  return hFetch<ContactHistoryVersion[]>({
    url: `/api/contacts/${contactId}/history`,
  });
};

type RejectionArgs = {
  send_email?: boolean;
  send_sms?: boolean;
  email_subject?: string;
  email_body?: string;
  sms_message?: string;
};

type UpdateContactArgs = {
  contactId: number;
  payload?: (FormData | Partial<ContactEntity>) & { rejection?: RejectionArgs };
};
export const updateContact = async ({ contactId, payload }: UpdateContactArgs) => {
  return (await deprecatedHFetch({ url: `/api/contacts/${contactId}`, method: 'PUT', payload })) as {
    status: 'error' | 'success';
    record?: ContactEntity;
    message?: string;
  };
};

type SendEmailArgs = {
  contactId: number;
  email: string;
  subject: string;
  body: string;
  files?: FileList | null;
};

export const sendContactEmail = ({ contactId, email, subject, body, files }: SendEmailArgs) => {
  const formData = new FormData();
  formData.append('email', email);
  formData.append('subject', subject);
  formData.append('body', body);
  formData.append('contact_id', String(contactId));

  if (files) {
    for (let i = 0; i < files.length; i++) {
      formData.append('email_files[]', files[i], files[i].name);
    }
  }

  return hFetch<{ message: string }, FormData>({
    url: `/api/contacts/${contactId}/send_email`,
    method: 'POST',
    payload: formData,
  });
};

type SendSmsArgs = {
  contactId: number;
  content: string;
};

export const getContactMessages = (contactId: number) => {
  return hFetch<ContactMessageEntity[]>({ url: `/api/contacts/${contactId}/contact_messages` });
};

export const sendContactMessage = ({ contactId, content }: SendSmsArgs) => {
  return hFetch<{ message: string }, { content: string }>({
    url: `/api/contacts/${contactId}/send_message`,
    method: 'POST',
    payload: { content },
  });
};

type OnboardContactArgs = {
  contactId: number;
  selectedTaskChecklistId?: number;
};
export const onboardContact = async ({ contactId, selectedTaskChecklistId }: OnboardContactArgs) => {
  return (await deprecatedHFetch({
    url: `/api/contacts/${contactId}/onboard`,
    method: 'POST',
    payload: {
      task_checklist_id: selectedTaskChecklistId,
    },
  })) as {
    status: 'error' | 'success';
    message?: string;
  };
};
